module.exports = __webpack_public_path__ + "img/UTHYRU-2.d690fc83.jpg";